export default __webpack_public_path__ + "static/media/7B3_ortega--chris.84a3f2be.png";